import axios from 'axios'
import {  Message } from 'element-ui'
import { Loading } from 'element-ui';
import { getToken } from '@/utils/auth'
import store from "@/store";
import {  getUrl } from '@/utils/baseurl'

let loading
let isShowLoading = true
const service = axios.create({
  // baseURL: "http://lfdc.net.cn:8845",
  // baseURL: process.env.EXTERNAL_URL,
  baseURL: getUrl(),
  timeout: 50000 // request timeout
})



// request interceptor
service.interceptors.request.use(
  // Loading.service(options),
  config => {
    // console.log(store.getters)
    config.baseURL = getUrl()
    if (isShowLoading){
      loading = Loading.service({
        lock: false,
        text: '正在加载',
        background: 'rgba(0, 0, 0,  0.8)'})
    }
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
    if (store.getters.token) {
      config.headers['x-token'] = getToken()
    }
    // config.responseType = 'json'
    return config
  },
  error => {
    loading.close()
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
const whiteList = [
  'http://lfdc.net.cn:8845/api/echarts',
  'http://lfdc.net.cn:8845/api/getScoreSummary',
  'http://lfdc.net.cn:8845/api/getChejianProblemList',
  'http://lfdc.net.cn:8845/api/countChejianList',
  'http://lfdc.net.cn:8845/api/getRecentlyProblemList',
  'http://lfdc.net.cn:8845/api/getAddressData'
]
// response interceptor
service.interceptors.response.use(
  response => {
    // 如果返回的是 MP3 音频
    if (response.headers['content-type'] === 'audio/mpeg') {
      loading.close();
      return response;
    }
    // 检查是否需要导出Excel
    if (response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      loading.close()
      return response
    }
    if (response.headers['content-type'] === 'application/octet-stream') {
      loading.close()
      return response
    }
    const res = response.data
    if (whiteList.indexOf(response.config.url) !== -1){
      if (isShowLoading){
        loading.close()
      }
      return res
    }
    if (res.code !== 0) {
      Message({
        message: res.message || res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      loading.close()
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      if (isShowLoading){
        loading.close()
      }
      return res
    }
  },
  error => {
    // console.log('reserr' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    loading.close()
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js